/**
 * CompanySetupModal — модалка настройки компании при первом входе (1.32.0)
 *
 * Тонкая обёртка над CompanyDetailsForm с модальным затемнением.
 * Показывается через CompanySetupGate, пока в company_details не
 * сохранена таймзона. После сохранения модалка перестаёт появляться.
 *
 * Содержит ту же форму, что используется в SystemSettings для
 * редактирования — единый источник UI.
 */

import { C, F } from '../design-system/tokens';
import { Card } from '../design-system/atoms/Card';
import { CompanyDetailsForm } from './CompanyDetailsForm';

interface CompanySetupModalProps {
  companyId: string;
  /** Можно ли закрыть модалку без сохранения. По умолчанию true для
   *  первого входа; передаём false, если открываем как edit-форму. */
  allowSkip?: boolean;
  onClose: () => void;
  onSaved?: () => void;
}

export function CompanySetupModal({
  companyId,
  allowSkip = true,
  onClose,
  onSaved,
}: CompanySetupModalProps) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflowY: 'auto',
        padding: '24px 12px',
      }}
    >
      <Card
        onClick={(e) => e.stopPropagation()}
        style={{ width: '100%', maxWidth: 560, padding: 24, background: C.card, position: 'relative' }}
      >
        {/* Крестик закрытия — всегда доступен. Закрытие не зависит от allowSkip
            (allowSkip управляет только наличием кнопки «Пропустить» в форме). */}
        <button
          type="button"
          onClick={onClose}
          aria-label="Закрыть"
          style={{
            position: 'absolute',
            top: 14,
            right: 14,
            width: 32,
            height: 32,
            borderRadius: 8,
            border: `1px solid ${C.b}`,
            background: C.surf,
            color: C.sub,
            fontSize: 16,
            lineHeight: 1,
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          ✕
        </button>
        <div style={{ marginBottom: 16, paddingRight: 40 }}>
          <div style={{ fontSize: 22, fontFamily: F.head, fontWeight: 800, color: C.txt }}>
            Настройка компании
          </div>
          <div style={{ fontSize: 13, color: C.sub, marginTop: 4 }}>
            Заполните данные о компании. Обязательно — только часовой пояс.
          </div>
        </div>

        <CompanyDetailsForm
          companyId={companyId}
          allowSkip={allowSkip}
          onClose={onClose}
          onSaved={onSaved}
        />
      </Card>
    </div>
  );
}
